export const TAB_NODE_INFORMATION = 0
export const TAB_NODE_CENTRALIZATION = 1
export const TAB_NODE_MEMBERS = 2
